(function () {
  'use strict';

  // Scope is intentionally limited to the three Damme cafe-curtain products.
  // Only the visible option thumbnail is replaced. Existing BCPO values and
  // data-image attributes remain untouched so color clicks keep using each
  // product's own scene image in the main gallery.
  var targetHandles = new Set([
    'best-custom-sheer-cafe-drapes-for-kitchen-windows-damme-41',
    'sheer-cafe-curtains-for-white-kitchen',
    'sheer-cafe-curtains-for-small-windows'
  ]);

  var fabricCards = new Map([
    ['D02-D1099-87', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D02-D1099-87_Rice_White.jpg?v=1721973869'],
    ['D06-D1099-37', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D06-D1099-37_Bleach_White.jpg?v=1721973870'],
    ['D366-D168-1', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-1_Rice_White.jpg?v=1721973869'],
    ['D366-D168-3', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-3_Beige.jpg?v=1721973869'],
    ['D366-D168-7', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-7_Pale_Crimson.jpg?v=1721973869'],
    ['D366-D168-8', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-8_Red_Plun_powder.jpg?v=1721973869'],
    ['D366-D168-16', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-16_Apple_Green.jpg?v=1721973869'],
    ['D366-D168-20', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-20_Soft_And_Tender_Blue.jpg?v=1721973869'],
    ['D366-D168-21', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-21_Ocean_Blue.jpg?v=1721973869'],
    ['D366-D168-25', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-25_Light_Yellow.jpg?v=1721973869'],
    ['D366-D168-30', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-30_Hermes_Orange.jpg?v=1721973869'],
    ['D366-D168-37', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-37_Blue_And_White_Color.jpg?v=1721973870'],
    ['D366-D168-42', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D366-D168-42_Dark_Grey.jpg?v=1721973869'],
    ['D368-D108-3', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D368-D108-3_Raw_White.jpg?v=1721973869'],
    ['D380-D118-01', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D380-D118-01_Bleach_White.jpg?v=1721973869'],
    ['D392-D1699-41', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D392-D1699-41_Raw_White.jpg?v=1721973869'],
    ['D396-D1799-30', 'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/D396-D1799-30_Rice_White.jpg?v=1721973869']
  ]);

  function getCode(value) {
    var match = String(value || '').toUpperCase().match(/#?([A-Z0-9]+(?:-[A-Z0-9]+)+)/);
    return match ? match[1] : '';
  }

  function getCard(value) {
    return fabricCards.get(getCode(value)) || '';
  }

  function cssUrl(url) {
    return 'url("' + String(url).replace(/"/g, '%22') + '")';
  }

  function setImportant(element, property, value) {
    if (!element) return;
    if (
      element.style.getPropertyValue(property) === value &&
      element.style.getPropertyPriority(property) === 'important'
    ) return;
    element.style.setProperty(property, value, 'important');
  }

  function applyCardToImage(image, card) {
    if (!image || !card) return;
    if (image.getAttribute('src') !== card) image.setAttribute('src', card);
    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    image.setAttribute('data-fd-cafe-fabric-card', '20260903');
  }

  function applyGeneratedCards(root, appliedCodes) {
    root.querySelectorAll('[data-fd-template-bcpo-color]').forEach(function (button) {
      var value = button.dataset.value || button.dataset.label || button.textContent;
      var code = getCode(value);
      var card = fabricCards.get(code) || '';
      if (!card) return;

      // Do not change button.dataset.image: it is the scene image used by the
      // existing main-gallery click handler.
      button.setAttribute('data-fd-cafe-fabric-card', '20260903');
      button.setAttribute('data-fd-cafe-fabric-code', code);
      var chip = button.querySelector('.fd-pdp-swatch__chip');
      if (chip) {
        setImportant(chip, 'background-image', cssUrl(card));
        chip.querySelectorAll('img').forEach(function (image) {
          applyCardToImage(image, card);
        });
      }
      appliedCodes.add(code);
    });
  }

  function nativeChoiceValue(choice) {
    var input = choice.querySelector('input[type="radio"], input[type="checkbox"], input');
    return (input && input.value) || choice.dataset.fdColorName || choice.textContent || '';
  }

  function applyNativeCards(root, appliedCodes) {
    root.querySelectorAll('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent').forEach(function (choice) {
      var value = nativeChoiceValue(choice);
      var code = getCode(value);
      var card = getCard(value);
      if (!card) return;

      var label = choice.querySelector('.bcpo-front-image-label, .bcpo-front-color-label, label');
      if (!label) return;
      choice.setAttribute('data-fd-cafe-fabric-card', '20260903');
      choice.setAttribute('data-fd-cafe-fabric-code', code);
      setImportant(label, 'background-image', cssUrl(card));
      label.querySelectorAll('img').forEach(function (image) {
        applyCardToImage(image, card);
      });
      appliedCodes.add(code);
    });
  }

  function applyCards(root) {
    if (!root || !targetHandles.has(String(root.dataset.productHandle || '').trim())) return;
    var appliedCodes = new Set();
    applyGeneratedCards(root, appliedCodes);
    applyNativeCards(root, appliedCodes);
    root.setAttribute('data-fd-cafe-fabric-card-fix', '20260903');
    root.setAttribute('data-fd-cafe-fabric-card-count', String(appliedCodes.size));
    root.setAttribute('data-fd-cafe-fabric-card-expected', '17');
  }

  function start(root) {
    if (!root || root.dataset.fdCafeFabricCardGuard === '20260903') return;
    if (!targetHandles.has(String(root.dataset.productHandle || '').trim())) return;
    root.dataset.fdCafeFabricCardGuard = '20260903';

    var queued = false;
    var apply = function () {
      queued = false;
      applyCards(root);
    };
    apply();

    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(apply);
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'src', 'srcset']
    });

    [100, 300, 700, 1500, 3000, 6000].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  function boot() {
    document.querySelectorAll('[data-fd-product]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
